import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormControlName } from '@angular/forms';
import { AlertService } from '../../services/alert/alert.service';
import { LoadingService } from '../../services/loading/loading.service';
import { DataService } from '../../services/data.service';
import { RatefileOpenService } from '../../services/ratefile-open/ratefile-open.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ControlKeys } from '../ratefile-open/control-keys';



@Component({
    selector: 'app-hhg-ratefile-open',
    templateUrl: './hhg-ratefile-open.component.html',
    styleUrls: ['./hhg-ratefile-open.component.css'],
    standalone: false
})
export class HhgRatefileOpenComponent implements OnInit {
  controlTypeSelected: any;
  fileTypeSelected: any;
  controlIdSelected: number;
  rateFileRecord: ControlKeys;
  rateFileDetails: ControlKeys[];
  rateKeyDetails: ControlKeys[];
  controlKeys: ControlKeys;
  lastControlRecord: any;
  rateKeySelected: number;
  updateSuccessful = false;
  updateFailure = false;
  buttonDisable = false;
  currentRateKey: number;
  validationError = false;
  openMinDate: Date;
  closeMinDate: Date;
  frtOptionsMore: any[] = [
    { name: 'Create Bid Segment', value: 'Main Rate Filing' },
    { name: 'TSP Participation', value: 'TSP Participation' },
    { name: 'Modify Effective Date', value: 'Rate Effective Dates' }
  ];
  frtOptionsLess: any[] = [
    { name: 'Create Bid Segment', value: 'Main Rate Filing' },    
    { name: 'Modify Effective Date', value: 'Rate Effective Dates' }
  ];
  frtOptions: any[];
  hhgOptions: any[] = [
    { name: 'Main Rate Filing', value: 'Main Rate Filing' },
    { name: 'Supplemental Rate Filing', value: 'Supplemental Rate Filing' },
    { name: 'Rate Effective Dates', value: 'Rate Effective Dates' }
  ];
  datePickerConfig: Partial<BsDatepickerConfig>;
  rateFileOpenForm: UntypedFormGroup;

  frtDropdownOption : boolean;
  bidCycleName: string;
  openDateError1: boolean;
  openDateError2: boolean;
  closeDateError1: boolean;  
  closeDateError2: boolean;
  openDateErrorMsg1: string;
  openDateErrorMsg2: string;
  closeDateErrorMsg1: string;
  closeDateErrorMsg2: string;


  constructor(private ratefileOpenService: RatefileOpenService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private dataService: DataService,
    private router: Router
  ) {

    this.createForm();
    this.rateFileOpenForm.controls['rateType'].setValue('HHG');
    this.formReset();
  }

  ngOnInit() {
    this.rateFileOpenForm.controls['rateType'].setValue('HHG');
  }
  goBack(){
    this.updateSuccessful = false;
    this.updateFailure = false;
    this.createForm();
    this.rateFileOpenForm.controls['rateType'].setValue('HHG');
    this.formReset();
  }

  formReset() {
    this.rateFileOpenForm.controls['rateKind'].setValue(null);
    this.rateFileOpenForm.controls['openDate'].setValue('');
    this.rateFileOpenForm.controls['closeDate'].setValue('');
    this.rateFileOpenForm.controls['releaseDate'].setValue('');
    this.openMinDate = new Date();
    this.closeMinDate = new Date();
    this.openMinDate.setDate(this.openMinDate.getDate());
    this.closeMinDate.setDate(this.closeMinDate.getDate());
    this.rateFileOpenForm.controls['controlId'].setValue(0);
    this.rateFileOpenForm.controls['rateKey'].setValue(0);
    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: this.openMinDate,
        dateInputFormat: 'MM/DD/YYYY'
      });
  }

  createForm() {
    this.rateFileOpenForm = this.fb.group({
      rateType: new UntypedFormControl('', [Validators.required]),
      rateKind: new UntypedFormControl('', [Validators.required]),
      openDate: new UntypedFormControl('', [Validators.required]),
      closeDate: new UntypedFormControl('', [Validators.required]),
      releaseDate: new UntypedFormControl('', [Validators.required]),
      bidCycle: new UntypedFormControl('', [Validators.required]),
      controlId: new UntypedFormControl(''),
      rateKey: new UntypedFormControl('')
    });
  }



  changeRateKind(event: any) {    
    this.rateFileOpenForm.controls['openDate'].setValue('');
    this.rateFileOpenForm.controls['closeDate'].setValue('');
    this.rateFileOpenForm.controls['releaseDate'].setValue('');
    this.rateFileOpenForm.controls['bidCycle'].setValue('');
    if (this.rateFileOpenForm.controls['rateKind'].value === 'TSP Participation'){
      this.rateFileOpenForm.controls['bidCycle'].setValue(this.bidCycleName);
    }
    if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' &&
      this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
      this.controlTypeSelected = 'HHG Rate Filing';
      this.fileTypeSelected = 'Main';
    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing' &&
      this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
      this.controlTypeSelected = 'HHG Rate Filing';
      this.fileTypeSelected = 'Supplemental';
    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' &&
      this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
      this.controlTypeSelected = 'FRT Rate Filing';
      this.fileTypeSelected = 'Main';
    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' ||
      this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing') {
      this.tmssLoader.show();      
      this.ratefileOpenService.getRateFileRecord(this.controlTypeSelected, this.fileTypeSelected).subscribe(rateFileRecords => {
        this.rateFileDetails = rateFileRecords as ControlKeys[];
        rateFileRecords.forEach(raterec => {
          rateFileRecords.effectiveDate = raterec.effectiveDate;
          rateFileRecords.expiryDate = raterec.expiryDate;
          rateFileRecords.releaseDate = raterec.releaseDate;
          rateFileRecords.cycleName = raterec.cycleName;
          rateFileRecords.controlId = raterec.controlId;
          this.rateFileOpenForm.controls['releaseDate'].setErrors(null);
          this.rateFileOpenForm.controls['closeDate'].setErrors(null);
          this.rateFileOpenForm.controls['bidCycle'].setErrors(null);
          this.tmssLoader.hide();
        }, (error) => {
          this.tmssLoader.hide();
          this.alertService.error('Rate File Record did not get populated: ' + error);
        });
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Error loading Rate File Record: ' + error);
      });      
      if (parseInt(this.rateFileOpenForm.controls['rateKey'].value) === 0) {        
        this.buttonDisable = false;
      }
    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'Rate Effective Dates') {
      if (this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
        this.controlTypeSelected = 'HHG Rate Effective Dates';
      }

      if (this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
        this.controlTypeSelected = 'FRT Rate Effective Dates';
      }
      this.tmssLoader.show();
      this.ratefileOpenService.getRateFileRecordForControlType(this.controlTypeSelected)
        .subscribe(rateFileRecords => {
          this.rateFileDetails = rateFileRecords as ControlKeys[];
          rateFileRecords.forEach(raterec => {
            rateFileRecords.effectiveDate = raterec.effectiveDate;
            rateFileRecords.expiryDate = raterec.expiryDate;
            rateFileRecords.controlId = raterec.controlId;
            this.tmssLoader.hide();
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get populated: ' + error);
          });
        }, (error) => {
          this.tmssLoader.hide();
          this.alertService.error('Error loading Rate File Record: ' + error);
        });
      this.rateFileOpenForm.controls['releaseDate'].setErrors(null);
      this.rateFileOpenForm.controls['bidCycle'].setErrors(null);
    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'TSP Participation' &&
      this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
      this.controlTypeSelected = 'FRT Bid Cycle';
      this.tmssLoader.show();
      this.ratefileOpenService.getRateFileRecordForControlType(this.controlTypeSelected)
        .subscribe(rateFileRecords => {
          this.rateFileDetails = rateFileRecords as ControlKeys[];    
          rateFileRecords.forEach(raterec => {
            rateFileRecords.effectiveDate = raterec.effectiveDate;
            rateFileRecords.expiryDate = raterec.expiryDate;
            rateFileRecords.controlId = raterec.controlId;
            rateFileRecords.cycleName = raterec.cycleName;
            this.tmssLoader.hide();
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get populated');
          });
        }, (error) => {
          this.tmssLoader.hide();
          this.alertService.error('Error loading Rate File Record');
        });
      this.rateFileOpenForm.controls['releaseDate'].setErrors(null);
      this.rateFileOpenForm.controls['bidCycle'].setErrors(null);
    }

    if (this.rateFileOpenForm.controls['rateKind'].value === "null") {
      this.formReset();
    }
  }
  openDateChange(openDate : Date){    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.openDateErrorMsg1 = '';
    this.openDateErrorMsg2 = '';
    this.openDateError1 = false;
    this.openDateError2 = false;
    this.validationError = false;
    let closeDate = null;
    let releaseDate = null;
  
    /*if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);
      openDate.setHours(0,0,0,0);
    }*/
    if (this.rateFileOpenForm.controls['closeDate'].value !== null) {
      closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);
      //closeDate.setHours(0,0,0,0);
    }
    if (this.rateFileOpenForm.controls['releaseDate'].value !== null) {
      releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);
      //releaseDate.setHours(0,0,0,0);
    }
    
    //if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' ||
      //this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing') {     
    if (openDate !== null && closeDate !== null && openDate > closeDate) {       
        this.openDateErrorMsg1 = 'Ratefiling Open Date can\'t be greater than the Ratefiling Close Date';
        this.validationError = true;
        this.openDateError1 = true;
      } else if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
        this.openDateErrorMsg2 = 'Ratefiling Open Date can\'t be greater than the Ratefiling Release Date';
        this.validationError = true;
        this.openDateError2 = true;
      }
    //} 
  }
  closeDateChange(closeDate : Date){    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.closeDateErrorMsg1 = '';
    this.closeDateErrorMsg2 = '';  
    this.closeDateError1 = false;  
    this.closeDateError2 = false;
    this.validationError = false; 
    let openDate = null;
    let releaseDate = null;    
    
    if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);
      //releaseDate.setHours(0,0,0,0);
    }
    if (this.rateFileOpenForm.controls['releaseDate'].value !== null) {
      releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);
      //releaseDate.setHours(0,0,0,0);
    }
    
    //if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' ||
      //this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing') {     
    if (closeDate !== null && releaseDate !== null && closeDate > releaseDate) {
        this.closeDateErrorMsg1 = 'Ratefiling Close Date can\'t be greater than Release Date';
        this.validationError = true;
        this.closeDateError1 = true;
      }
      if (closeDate !== null && openDate !== null && openDate > closeDate) {
        this.closeDateErrorMsg2 = 'Ratefiling Open Date can\'t be greater than Close Date';
        this.validationError = true;
        this.closeDateError2 = true;
      }
    //}
  }
  
  public markControlsAsTouched(rootControl: UntypedFormGroup | UntypedFormArray,
    visitChildren: boolean = true) {

    const stack: (UntypedFormGroup | UntypedFormArray)[] = [];

    // Stack the root FormGroup or FormArray
    if (rootControl &&
      (rootControl instanceof UntypedFormGroup || rootControl instanceof UntypedFormArray)) {
      stack.push(rootControl);
    }
    while (stack.length > 0) {
      const currentControl = stack.pop();
      (<any>Object).values(currentControl.controls).forEach((control) => {
        // If there are nested forms or formArrays, stack them to visit later
        if (visitChildren &&
          (control instanceof UntypedFormGroup || control instanceof UntypedFormArray)
        ) {          
          stack.push(control);
        } else {    
          control.markAsTouched();
          control.setErrors(null);
        }
      });
    }
  }

  selectedRecord(controlId, i) {  
    this.rateFileOpenForm.controls['openDate'].setValue(null);
      this.rateFileOpenForm.controls['closeDate'].setValue(null);
      this.rateFileOpenForm.controls['releaseDate'].setValue(null);
    this.tmssLoader.show();
    this.controlIdSelected = controlId;
    this.ratefileOpenService.getRateFileRecorForId(this.controlIdSelected).subscribe(ratefileRecord => {
      this.rateFileRecord = ratefileRecord;
      this.rateFileOpenForm.controls['openDate'].setValue(this.rateFileRecord.effectiveDate);
      this.rateFileOpenForm.controls['closeDate'].setValue(this.rateFileRecord.expiryDate);
      this.rateFileOpenForm.controls['releaseDate'].setValue(this.rateFileRecord.releaseDate);
      this.rateFileOpenForm.controls['bidCycle'].setValue(this.rateFileRecord.cycleName);
      this.rateFileOpenForm.controls['controlId'].setValue(this.rateFileRecord.controlId);
      this.rateFileOpenForm.controls['rateKey'].setValue(this.rateFileRecord.rateKey);
    
      //if(i !== 0){
      if(this.rateFileRecord.releasePending != 'Pending'){
        this.rateFileOpenForm.controls['openDate'].disable();
        this.rateFileOpenForm.controls['closeDate'].disable();
        this.rateFileOpenForm.controls['releaseDate'].disable();
        this.rateFileOpenForm.controls['bidCycle'].disable();
      } else{
        this.rateFileOpenForm.controls['openDate'].enable();
        this.rateFileOpenForm.controls['closeDate'].enable();
        this.rateFileOpenForm.controls['releaseDate'].enable();
        this.rateFileOpenForm.controls['bidCycle'].enable();
      }
      if (this.rateFileOpenForm.controls['closeDate'].value === '' ||
        this.rateFileOpenForm.controls['closeDate'].value === null) {
        this.rateFileOpenForm.controls['closeDate'].setErrors(null);
      }
      if (this.rateFileOpenForm.controls['releaseDate'].value === '' ||
        this.rateFileOpenForm.controls['releaseDate'].value === null) {
        this.rateFileOpenForm.controls['releaseDate'].setErrors(null);
      }
      if (this.rateFileOpenForm.controls['bidCycle'].value === '') {
        this.rateFileOpenForm.controls['bidCycle'].setErrors(null);
      }
      this.currentRateKey = this.rateFileDetails[0].rateKey;
      if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' || this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing') {
       
        if (this.currentRateKey === parseInt(this.rateFileOpenForm.controls['rateKey'].value)) {         
          this.buttonDisable = false;
        } else {
          this.buttonDisable = true;
        }
      }
      this.tmssLoader.hide();
    }, (error) => {
      this.alertService.error('Rate File Record did not get populated');
      this.tmssLoader.hide();
    });
  }

  clearPage() {
    this.tmssLoader.show();
    this.rateFileOpenForm.controls['openDate'].setValue('');
    this.rateFileOpenForm.controls['closeDate'].setValue('');
    this.rateFileOpenForm.controls['releaseDate'].setValue('');
    this.tmssLoader.hide();
  }

  getLastRateKey() { 
    this.ratefileOpenService.getRateFileRecordForControlType(this.controlTypeSelected)
      .subscribe(rateFileRecords => {
        this.rateKeyDetails = rateFileRecords as ControlKeys[];
        rateFileRecords.forEach(raterec => {
          rateFileRecords.effectiveDate = raterec.effectiveDate;
          rateFileRecords.expiryDate = raterec.expiryDate;
          rateFileRecords.controlId = raterec.controlId;
        }, (error) => {
          this.alertService.error('Rate File Record did not get populated');
          this.tmssLoader.hide();
        });
        this.lastControlRecord = (rateFileRecords[0]);
      });

  }

  SaveRateFileRec() {
    this.openDateError1 = false;
    this.openDateError2 = false;
    this.closeDateError1 = false;
    this.closeDateError2 = false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let openDate = null;
    let closeDate = null;
    let releaseDate = null;
   
    if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);
    }
    if (this.rateFileOpenForm.controls['closeDate'].value !== null) {
      closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);
    }
    if (this.rateFileOpenForm.controls['releaseDate'].value !== null) {
      releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);
    }


   
    // this.getLastRateKey();

 

    if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' ||
      this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing') {
    
      /*if  (openDate !== null && openDate < today) {
        console.log('Ratefileing Open Date can\'t be less than today');
        this.alertService.error('Ratefileing Open Date can\'t be less than today');
        this.validationError = true;
      } else if*/ 
      if (openDate !== null && closeDate !== null && openDate > closeDate) {        
        //this.alertService.error('Ratefiling Open Date can\'t be greater than the Ratefiling Close Date');
        this.openDateError1 = true;
        this.validationError = true;
      } else if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
        //this.alertService.error('Ratefiling Open Date can\'t be greater than the Ratefiling Release Date');
        this.openDateError2 = true;
        this.validationError = true;
      }

      if (closeDate !== null && closeDate < today) {
        this.alertService.error('Ratefileing Close Date can\'t be less than today');
        this.closeDateError1 = true;
        this.validationError = true;
      } else if (closeDate !== null && releaseDate !== null && closeDate > releaseDate) {        
        //this.alertService.error('Ratefileing Close Date can\'t be greater than Release Date');       
        this.validationError = true;
      }

      this.controlKeys = new ControlKeys();

      if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' &&
        this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
        this.controlKeys.controlType = 'HHG Rate Filing';
        this.controlKeys.filingType = 'Main';
      }

      if (this.rateFileOpenForm.controls['rateKind'].value === 'Supplemental Rate Filing' &&
        this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
        this.controlKeys.controlType = 'HHG Rate Filing';
        this.controlKeys.filingType = 'Supplemental';
      }

      if (this.rateFileOpenForm.controls['rateKind'].value === 'Main Rate Filing' &&
        this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
        this.controlKeys.controlType = 'FRT Rate Filing';
        this.controlKeys.filingType = 'Main';
      }
      this.rateKeySelected = this.rateFileDetails[0].rateKey;

      if (this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
        if (parseInt(this.rateFileOpenForm.controls['rateKey'].value) === 0) {
          this.controlKeys.rateKey = this.rateKeySelected + 2;          
        } else {          
          this.controlKeys.rateKey = parseInt(this.rateFileOpenForm.controls['rateKey'].value);
        }
      }
      if (this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
        if (parseInt(this.rateFileOpenForm.controls['rateKey'].value) === 0) {          
          this.controlKeys.rateKey = this.rateKeySelected + 1;
        } else {
          this.controlKeys.rateKey = parseInt(this.rateFileOpenForm.controls['rateKey'].value);
        }
      }      
      if (this.rateFileOpenForm.controls['controlId'].value !== 0) {
        this.controlKeys.controlId = this.rateFileOpenForm.controls['controlId'].value;
      }
      this.controlKeys.effectiveDate = this.rateFileOpenForm.controls['openDate'].value;
      if (this.rateFileOpenForm.controls['closeDate'].value === null) {
        this.controlKeys.expiryDate = 0;
      } else {
        this.controlKeys.expiryDate = this.rateFileOpenForm.controls['closeDate'].value;
      }

      if (this.validationError === false) {
        this.controlKeys.releaseDate = this.rateFileOpenForm.controls['releaseDate'].value;
        this.controlKeys.cycleName = this.rateFileOpenForm.controls['bidCycle'].value;
        this.controlKeys.releasePending = 'Pending';
        this.controlKeys.updateProgram = 'Rate_File_Open';
        this.controlKeys.updateDate = today;
        this.controlKeys.updateId = 0;      
        this.tmssLoader.show();
        this.updateSuccessful = false;
        this.updateFailure = false;
        this.ratefileOpenService.createControlKeys(this.controlKeys)
          .subscribe(data => {
            if (data.controlId !== 0) {              
              this.updateFailure = false;
              this.updateSuccessful = true;
              this.controlIdSelected = data.controlId;
             /* this.rateFileOpenForm.controls['openDate'].setValue('');
              this.rateFileOpenForm.controls['closeDate'].setValue('');
              this.rateFileOpenForm.controls['releaseDate'].setValue('');
              this.rateFileOpenForm.controls['bidCycle'].setValue(''); */
             
              this.rateFileDetails = [];             
              this.ratefileOpenService.getRateFileRecord(this.controlKeys.controlType, this.controlKeys.filingType)
                .subscribe(rateFileRecords => {                
                  this.rateFileDetails = rateFileRecords as ControlKeys[];
                  rateFileRecords.forEach(raterec => {
                    rateFileRecords.effectiveDate = raterec.effectiveDate;
                    rateFileRecords.expiryDate = raterec.expiryDate;
                    rateFileRecords.releaseDate = raterec.releaseDate;
                    rateFileRecords.controlId = raterec.controlId;
                    rateFileRecords.cycleName = raterec.cycleName;
                    this.tmssLoader.hide();
                  }, (error) => {
                    this.tmssLoader.hide();
                    this.alertService.error('Rate File Record did not get populated');
                    this.updateFailure = true;
                    this.updateSuccessful = false;
                  });
                  this.ratefileOpenService.sendEmail(this.controlIdSelected)
                    .subscribe(result => {
                      console.log(result);
                    });
                });
            } else {
              this.tmssLoader.hide();
              this.alertService.error('Control Id is zero ');
              this.updateFailure = true;
              this.updateSuccessful = false;
            }
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get updated');
            this.updateFailure = true;
            this.updateSuccessful = false;
          });
      }

    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'Rate Effective Dates') {
      if (openDate > closeDate) {
        this.alertService.error('Rate Effective Date cannot\' be greater than Expiry Date');
        this.validationError = true;
      }

      this.controlKeys = new ControlKeys();
      if (this.rateFileOpenForm.controls['rateType'].value === 'HHG') {
        this.controlKeys.controlType = 'HHG Rate Effective Dates';
      }

      if (this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
        this.controlKeys.controlType = 'FRT Rate Effective Dates';
      }

      if (this.validationError === false) {        
        this.rateKeySelected = this.rateFileDetails[0].rateKey;        
        if (parseInt(this.rateFileOpenForm.controls['controlId'].value) === 0) {
          this.controlKeys.rateKey = this.rateKeySelected + 1;
        } else {
          this.controlKeys.rateKey = this.rateKeySelected;
          this.controlKeys.controlId = parseInt(this.rateFileOpenForm.controls['controlId'].value);
        }

        this.controlKeys.effectiveDate = this.rateFileOpenForm.controls['openDate'].value;
        this.controlKeys.expiryDate = this.rateFileOpenForm.controls['closeDate'].value;
        this.controlKeys.releaseDate = this.rateFileOpenForm.controls['releaseDate'].value;
        this.controlKeys.cycleName = this.rateFileOpenForm.controls['bidCycle'].value;
        this.controlKeys.releasePending = null;
        this.controlKeys.filingType = null;
        this.controlKeys.updateProgram = 'Rate_File_Open';
        this.controlKeys.updateDate = today;
        this.controlKeys.updateId = 0;

        
        this.tmssLoader.show();
        this.updateSuccessful = false;
        this.updateFailure = false;
        this.ratefileOpenService.createControlKeys(this.controlKeys)
          .subscribe(data => {
            if (data.controlId !== 0) {              
              this.updateFailure = false;
              this.updateSuccessful = true;
              /*this.rateFileOpenForm.controls['openDate'].setValue('');
              this.rateFileOpenForm.controls['closeDate'].setValue('');
              this.rateFileOpenForm.controls['releaseDate'].setValue('');
              this.rateFileOpenForm.controls['bidCycle'].setValue('');*/          
              this.ratefileOpenService.getRateFileRecordForControlType(this.controlKeys.controlType)
                .subscribe(rateFileRecords => {
                  this.rateFileDetails = rateFileRecords as ControlKeys[];
                  rateFileRecords.forEach(raterec => {
                    rateFileRecords.effectiveDate = raterec.effectiveDate;
                    rateFileRecords.expiryDate = raterec.expiryDate;
                    rateFileRecords.releaseDate = raterec.releaseDate;
                    rateFileRecords.controlId = raterec.controlId;
                    rateFileRecords.cycleName = raterec.cycleName;
                    this.tmssLoader.hide();
                  }, (error) => {
                    this.tmssLoader.hide();
                    this.alertService.error('Rate File Record did not get populated');
                    this.updateFailure = true;
                    this.updateSuccessful = false;
                  });
                });
            } else {
              this.tmssLoader.hide();
              this.alertService.error('Rate File Record did not get populated');
              this.updateFailure = true;
              this.updateSuccessful = false;
            }
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get populated');
            this.updateFailure = true;
            this.updateSuccessful = false;
          });
      }

    }

    if (this.rateFileOpenForm.controls['rateKind'].value === 'TSP Participation') {
      if (openDate > closeDate) {
        this.alertService.error('Rate Effective Date can\' be greater than Expiry Date');
        this.validationError = true;
      }

      this.controlKeys = new ControlKeys();
      if (this.rateFileOpenForm.controls['rateType'].value === 'FRT') {
        this.controlKeys.controlType = 'FRT Bid Cycle';
      }

      if (this.validationError === false) {        
        this.rateKeySelected = this.rateFileDetails[0].rateKey;
        if (parseInt(this.rateFileOpenForm.controls['controlId'].value) === 0) {
          this.controlKeys.rateKey = this.rateKeySelected + 1;
        } else {
          this.controlKeys.rateKey = this.rateKeySelected;
          this.controlKeys.controlId = parseInt(this.rateFileOpenForm.controls['controlId'].value);
        }

        this.controlKeys.effectiveDate = this.rateFileOpenForm.controls['openDate'].value;
        this.controlKeys.expiryDate = this.rateFileOpenForm.controls['closeDate'].value;
        this.controlKeys.releaseDate = this.rateFileOpenForm.controls['releaseDate'].value;
        this.controlKeys.cycleName = this.rateFileOpenForm.controls['bidCycle'].value;
        this.controlKeys.releasePending = null;
        this.controlKeys.filingType = null;
        this.controlKeys.updateProgram = 'Rate_File_Open';
        this.controlKeys.updateDate = today;
        this.controlKeys.updateId = 0;

        this.tmssLoader.show();
        this.updateSuccessful = false;
        this.updateFailure = false;
        this.ratefileOpenService.createControlKeys(this.controlKeys)
          .subscribe(data => {
            if (data.controlId !== 0) {          
              this.updateFailure = false;
              this.updateSuccessful = true;
              /*this.rateFileOpenForm.controls['openDate'].setValue('');
              this.rateFileOpenForm.controls['closeDate'].setValue('');
              this.rateFileOpenForm.controls['releaseDate'].setValue('');
              this.rateFileOpenForm.controls['bidCycle'].setValue(''); */             
              this.ratefileOpenService.getRateFileRecordForControlType(this.controlKeys.controlType)
                .subscribe(rateFileRecords => {
                  this.rateFileDetails = rateFileRecords as ControlKeys[];
                  rateFileRecords.forEach(raterec => {
                    rateFileRecords.effectiveDate = raterec.effectiveDate;
                    rateFileRecords.expiryDate = raterec.expiryDate;
                    rateFileRecords.releaseDate = raterec.releaseDate;
                    rateFileRecords.controlId = raterec.controlId;
                    rateFileRecords.cycleName = raterec.cycleName;
                    this.tmssLoader.hide();
                  }, (error) => {
                    this.tmssLoader.hide();
                    this.alertService.error('Rate File Record did not get populated');
                    this.updateFailure = true;
                    this.updateSuccessful = false;
                  });
                });
            } else {
              this.tmssLoader.hide();
              this.alertService.error('Rate File Record did not get populated');
              this.updateFailure = true;
              this.updateSuccessful = false;
            }
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get populated');
            this.updateFailure = true;
            this.updateSuccessful = false;
          });
      }
    }
  /*  setTimeout(() => {
      this.rateFileOpenForm.controls['rateType'].setValue(null);
      this.formReset();
      this.updateFailure = false;
      this.updateSuccessful = false;
    }, 15000)*/
  }

  
  
}

